import React from 'react';
import { Grid } from '@mui/material';
import RepositoryHealthCard from './RepositoryHealthCard';
import RedundancyEfficiencyCard from './RedundancyEfficiencyCard';

const ProblemAreasSection = () => (
  <Grid container spacing={3} alignItems="stretch">
    <Grid item xs={12} md={6}>
      <RepositoryHealthCard sx={{ height: '100%' }} />
    </Grid>
    <Grid item xs={12} md={6}>
      <RedundancyEfficiencyCard sx={{ height: '100%' }} />
    </Grid>
  </Grid>
);

export default ProblemAreasSection;